<template>
  <v-container>
    <v-card>
      <v-card-title>{{ t('agent.agentPerformance') }}</v-card-title>
      <v-card-text>
        <div style="height: 400px; width: 100%;">
        <v-chart ref="lineChartRef" :option="chartOptions" autoresize />
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script setup>
import { onMounted,ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { fetchAgentSalesPerformance } from '@/api/apiService'; 

const { t, locale } = useI18n();
const lineChartRef = ref(null);
const getLastSevenDays = () => {
  const language = locale.value;
  const daysOfWeek = [t("agentPerformance.sunday", {language}), t("agentPerformance.monday", {language}), t("agentPerformance.tuesday", {language}), t("agentPerformance.wednesday", {language}), t("agentPerformance.thursday", {language}), t("agentPerformance.friday", {language}), t("agentPerformance.saturday", {language})];
  const today = new Date();
  const lastSevenDays = [];

  for (let i = 0; i < 7; i++) {
    const day = new Date(today);
    day.setDate(today.getDate() - i);
    lastSevenDays.push(daysOfWeek[day.getDay()]);
  }

  return lastSevenDays.reverse(); // Reverse to get the order from past to present
}

const salesCount = ref([]);
const salesEarnings = ref([]);

const chartOptions = computed(() => {
  const language = locale.value;
  return {
    title: {
      text: t("agentPerformance.lastWeekSalesData"),
    },
    tooltip: {
      trigger: "axis",
    },
    legend: {
      data: [t("agentPerformance.salesCount", {language }), t("agentPerformaance.salesEarnings")]
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: getLastSevenDays(),
    },
    yAxis: {
      type: 'value'
    },
    series: [
      {
        name: t("agentPerformance.salesCount", {language}),
        type: 'line',
        data: salesCount.value,
        smooth: true
      }, {
      name: t("agentPerformance.salesEarnings", {language}),
      type: 'line',
      data: salesEarnings.value,
      smooth: true,
    },
    ],
  };
});
onMounted(async () => {
  // 获取数据
  // 更新 chartOptions
  try {
    const salesData = await fetchAgentSalesPerformance();
    salesCount.value = salesData.data.salesQuantity;
    salesEarnings.value = salesData.data.salesEarnings;
  } catch(err) {
    console.error(err);
  }
  console.log('Chart Options:', chartOptions.value);
});
</script>
